<template>
<div class="personnel-portrait-content">
  <div class="content-header">
    <e-form
      :list-type-info="formInfo.listTypeInfo"
      :field-list="formInfo.fieldList"
      :data="formInfo.data"
      @handleEvent="formChange('formInfo',$event)"
      ref="formRef"
    >
      <template v-slot:form-submit>
        <el-button type="primary" @click="queryInfo">查询</el-button>
        <el-button type="primary" @click="resetForm">重置</el-button>
      </template>
    </e-form>
  </div>
  <div class="content">
    <div class="content-row">
      <div class="content-column content-column-30 fix-chart-style">
        <div style="margin-top: 20px">
          <p>
            异常原因来源:
            <el-select
              @change="onSelectChange('type',$event)"
              v-model="originFirst.value" placeholder="请选择" size="mini">
              <el-option
                label="全部"
                :value="0"
              />
              <el-option
                label="外包商"
                :value="1"
              />
              <el-option
                label="内部"
                :value="2"
              />
            </el-select>
          </p>
          <p>
            异常原因合理性:
            <el-select
              @change="onSelectChange('type',$event)"
              v-model="rationalityFirst.value" placeholder="请选择" size="mini">
              <el-option
                label="全部"
                :value="0"
              />
              <el-option
                label="合理"
                :value="1"
              />
              <el-option
                label="不合理"
                :value="2"
              />
            </el-select>
          </p>
        </div>
        <chart
          :chartConfig="[
            {
                name:'pieChart',
                option: typeConfig.option,
                load: typeConfig.load,
                clear: typeConfig.clear
            }
          ]"
        />
      </div>
      <div class="content-column content-column-30 fix-chart-style">
        <div style="margin-top: 20px">
          <p>
          异常原因类型:
          <el-select
            @change="onSelectChange('origin',$event)"
            v-model="typeSecond.value"
            placeholder="请选择"
            size="mini">
            <el-option
              label="全部"
              :value="0"
            />
            <el-option
              label="作业技能不足"
              :value="1"
            />
            <el-option
              label="任务调度相关"
              :value="2"
            />
            <el-option
              label="假期"
              :value="3"
            />
            <el-option
              label="平台"
              :value="4"
            />
            <el-option
              label="培训/考试"
              :value="5"
            />
          </el-select>
          </p>
          <p>
          异常原因合理性:
          <el-select
            @change="onSelectChange('origin',$event)"
            v-model="rationalitySecond.value" placeholder="请选择" size="mini">
            <el-option
              label="全部"
              :value="0"
            />
            <el-option
              label="合理"
              :value="1"
            />
            <el-option
              label="不合理"
              :value="2"
            />
          </el-select>
          </p>
        </div>
        <chart
          :chartConfig="[
            {
                name:'pieChart',
                option: originConfig.option,
                load: originConfig.load,
                clear: originConfig.clear
            }
          ]"
        />
      </div>
      <div class="content-column content-column-30 fix-chart-style">
        <div style="margin-top: 20px">
          <p>
          异常原因来源:
          <el-select
            @change="onSelectChange('rationality',$event)"
            v-model="originThird.value" placeholder="请选择" size="mini">
            <el-option
              label="全部"
              :value="0"
            />
            <el-option
              label="外包商"
              :value="1"
            />
            <el-option
              label="内部"
              :value="2"
            />
          </el-select>
          </p>
          <p>
          异常原因类型:
          <el-select
            @change="onSelectChange('rationality',$event)"
            v-model="typeThird.value" placeholder="请选择" size="mini">
            <el-option
              label="全部"
              :value="0"
            />
            <el-option
              label="作业技能不足"
              :value="1"
            />
            <el-option
              label="任务调度相关"
              :value="2"
            />
            <el-option
              label="假期"
              :value="3"
            />
            <el-option
              label="平台"
              :value="4"
            />
            <el-option
              label="培训/考试"
              :value="5"
            />
          </el-select>
          </p>
        </div>
        <chart
          :chartConfig="[
            {
                name:'pieChart',
                option: rationalityConfig.option,
                load: rationalityConfig.load,
                clear: rationalityConfig.clear
            }
          ]"
        />
      </div>
    </div>
  </div>
</div>
</template>

<script>
import EForm from '@/components/EForm/index'
import chart from '@/components/chart/index'
import { formInfo } from '../OverallcomplianceDetail/config'
import {
  typeConfig,
  nameEnToZh,
  originConfig,
  rationalityConfig
} from './config'
import { common } from '@/views/personnel-workhourRemake/mixFun'
import { getUnusualRateDistribution } from '@/api/personnelWorkHour'
export default {
  name: 'Abnormal',
  mixins: [common],
  components: {
    chart,
    EForm
  },
  data () {
    return {
      formInfo,
      typeConfig,
      originConfig,
      rationalityConfig,
      nameEnToZh,
      formData: formInfo.data,
      originFirst: {
        value: 0
      },
      rationalityFirst: {
        value: 0
      },
      typeSecond: {
        value: 0
      },
      rationalitySecond: {
        value: 0
      },
      originThird: {
        value: 0
      },
      typeThird: {
        value: 0
      }
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    queryInfo () {
      this.formData = {
        ...this.formData,
        ...this.$refs.formRef.data
      }
      this.drawChart()
    },
    resetForm () {
      this.$refs.formRef.resetFields()
    },
    init () {
      this.drawChart()
    },
    drawChart () {
      this.getTypeData()
      this.getOriginData()
      this.getrationalityData()
    },
    // 设置数据为对应格式类型
    setPieSeriesData (data) {
      const tmp = []
      for (let key of Object.keys(data)) {
        const zhName = nameEnToZh.get(key)
        zhName && tmp.push({
          ...data,
          name: zhName,
          value: data[key]
        })
      }
      return tmp
    },
    // 获取异常原因类型数据
    async getTypeData (params) {
      this.typeConfig.load = true
      const res = await getUnusualRateDistribution({ ...this.formData, ...params, dimension: 'type' })
      this.typeConfig.option = {
        yAxis: {
          show: false
        },
        xAxis: {
          show: false
        },
        legend: {
          orient: 'vertical',
          right: 0,
          top: 'middle'
        },
        series: [
          {
            radius: '30%',
            center: ['33%', '50%'],
            type: 'pie',
            data: this.setPieSeriesData(res)
          }
        ]
      }
      this.typeConfig.load = false
    },
    // 获取异常原因来源数据
    async getOriginData (params) {
      this.originConfig.load = true
      const res = await getUnusualRateDistribution({ ...this.formData, ...params, dimension: 'origin' })
      this.originConfig.option = {
        yAxis: {
          show: false
        },
        xAxis: {
          show: false
        },
        legend: {
          orient: 'vertical',
          right: 0,
          top: 'middle'
        },
        series: [
          {
            radius: '30%',
            center: ['33%', '50%'],
            type: 'pie',
            data: this.setPieSeriesData(res)
          }
        ]
      }
      this.originConfig.load = false
    },
    // 获取合理性数据来源
    async getrationalityData (params) {
      this.rationalityConfig.load = true
      const res = await getUnusualRateDistribution({ ...this.formData, ...params, dimension: 'rationality' })
      this.rationalityConfig.option = {
        yAxis: {
          show: false
        },
        xAxis: {
          show: false
        },
        legend: {
          orient: 'vertical',
          right: 0,
          top: 'middle'
        },
        series: [
          {
            radius: '30%',
            center: ['33%', '50%'],
            type: 'pie',
            data: this.setPieSeriesData(res)
          }
        ]
      }
      this.rationalityConfig.load = false
    },
    onSelectChange (dimension, value) {
      switch (dimension) {
        case 'type':
          this.getTypeData({ origin: this.originFirst.value, rationality: this.rationalityFirst.value })
          break
        case 'origin':
          this.getOriginData({ type: this.typeSecond.value, rationality: this.rationalitySecond.value })
          break
        case 'rationality':
          this.getrationalityData({ origin: this.originThird.value, type: this.typeThird.value })
      }
    }
  }
}
</script>

<style scoped lang="less">
@import "../../../utils/utils";
.fix-chart-style{
  margin: 0 10px;
}
</style>
